module.exports = __webpack_public_path__ + "static/media/curology-min.601a4aa7.webp";